import type { VaultDocument, VaultDocumentFilter, VaultDocumentPort } from '../domain/document'

const listDocuments = async (port: VaultDocumentPort, filter: VaultDocumentFilter): Promise<VaultDocument[]> => port.list(filter)

export { listDocuments }
